import { action, observable } from "mobx";
import callApi from "../utils/callApi";

class NNLiveStore {

  @observable purchased = undefined;
  @observable loading = false;
  @observable modalDismissed = false;



  @action dismissModalInSession = () => {
    this.modalDismissed = true;
  }
}

export default new NNLiveStore();
